
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  ArrowLeft, 
  CreditCard, 
  Home, 
  Car, 
  Anchor, 
  Wrench, 
  Wallet,
  Check,
  Info,
  ShieldCheck
} from "lucide-react";

const ArabicPage = () => {
  return (
    <div className="rtl-layout" dir="rtl">
      <section className="relative py-12 md:py-20 bg-gradient-to-r from-blue-700 to-blue-900 overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6">خدمات القروض في فنلندا</h1>
            <p className="text-xl text-blue-100 mb-8">
              قارن واحصل على أفضل عروض القروض في فنلندا. احصل على المساعدة بلغتك لفهم نظام القروض الفنلندي.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/ar/apply" 
                className="bg-white hover:bg-blue-50 text-blue-700 px-6 py-3 rounded-lg font-semibold text-lg transition-colors shadow-lg"
                aria-label="قدم طلبًا للحصول على قرض واحصل على عروض من بنوك متعددة"
                title="قدم طلبًا الآن واحصل على أفضل عروض القروض في فنلندا"
              >
                قدم طلبًا للحصول على قرض
              </Link>
              <Link 
                to="/ar/info" 
                className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-lg font-semibold text-lg hover:bg-white/10 transition-colors"
                aria-label="اقرأ المزيد عن نظام القروض في فنلندا"
                title="معلومات مهمة حول كيفية عمل القروض في فنلندا"
              >
                اقرأ المزيد عن القروض
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 text-blue-700">أنواع القروض المتاحة في فنلندا</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <CreditCard className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">قرض استهلاكي</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">تمويل للمشتريات اليومية</p>
              <p className="text-xs text-gray-500">القروض الاستهلاكية في فنلندا تتيح لك تمويل المشتريات الكبيرة مثل الإلكترونيات والأثاث بأسعار فائدة تنافسية.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <Home className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">قرض سكني</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">تمويل ميسور للمنازل</p>
              <p className="text-xs text-gray-500">القروض السكنية في فنلندا تتميز بأسعار فائدة منخفضة نسبيًا وفترات سداد طويلة تصل إلى 25 عامًا.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <Car className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">قرض السيارة</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">تمويل لسيارة أحلامك</p>
              <p className="text-xs text-gray-500">الحصول على قرض سيارة في فنلندا يمكن أن يكون أكثر اقتصادا من خيارات التمويل التي تقدمها وكالات السيارات.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <Anchor className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">قرض القارب</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">لشراء وصيانة القوارب</p>
              <p className="text-xs text-gray-500">قروض القوارب مصممة خصيصًا لتمويل شراء أو إصلاح أو تحديث القوارب الترفيهية في فنلندا.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <Wrench className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">قرض التجديد</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">تمويل لتحسينات المنزل</p>
              <p className="text-xs text-gray-500">قروض التجديد تساعدك على تمويل إصلاحات المنزل والتحسينات التي تزيد من قيمة عقارك في فنلندا.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
            
            <div className="bg-blue-50 p-5 rounded-xl hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                <Wallet className="h-8 w-8 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">دمج القروض</h3>
              </div>
              <p className="text-sm text-gray-600 mb-2">دمج القروض وتوفير التكاليف</p>
              <p className="text-xs text-gray-500">دمج القروض المتعددة في قرض واحد يمكن أن يقلل من مدفوعاتك الشهرية ويبسط إدارة ديونك في النظام الفنلندي.</p>
              <div className="mt-4">
                <Link 
                  to="/ar/apply" 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center justify-end"
                >
                  تقدم بطلب الآن
                  <ArrowLeft className="mr-1 h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-blue-700">لماذا تختار خدماتنا؟</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <ShieldCheck className="h-6 w-6 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">مقارنة مجانية</h3>
              </div>
              <p className="text-sm text-gray-600">
                قارن بين عروض القروض من بنوك متعددة دفعة واحدة، بشكل مجاني تمامًا.
              </p>
            </div>
            
            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <Check className="h-6 w-6 text-green-500 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">استجابة سريعة</h3>
              </div>
              <p className="text-sm text-gray-600">
                احصل على عروض القروض في غضون 24 ساعة. لا حاجة للأوراق أو زيارات البنوك.
              </p>
            </div>
            
            <div className="bg-white p-5 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                <Info className="h-6 w-6 text-blue-600 ml-3" />
                <h3 className="text-lg font-medium text-gray-800">وفر المال</h3>
              </div>
              <p className="text-sm text-gray-600">
                اعثر على أفضل أسعار الفائدة ووفر آلاف اليورو على مدى فترة القرض.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-6">جاهز للعثور على أفضل قرض؟</h2>
            <p className="text-lg text-blue-100 mb-8">
              املأ طلبًا واحدًا وسنعثر لك على أفضل العروض.
            </p>
            <Link 
              to="/ar/apply" 
              className="bg-white hover:bg-gray-100 text-blue-700 px-6 py-3 rounded-lg font-semibold text-lg transition-colors shadow-lg inline-block"
            >
              قدم طلبك الآن
            </Link>
          </div>
        </div>
      </section>

      <div className="bg-blue-50 py-8 text-center">
        <Link 
          to="/" 
          className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
          aria-label="العودة إلى الصفحة الرئيسية باللغة الفنلندية"
          title="الانتقال إلى النسخة الفنلندية من الموقع"
        >
          <ArrowLeft className="ml-2" />
          العودة إلى الصفحة الرئيسية
        </Link>
      </div>
    </div>
  );
};

export default ArabicPage;
